import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Box } from "@mui/material";
import { MyTimeShowRequestCard } from "my-time/components";
import { useMyTimeMessagesList, useMyTimeRequest } from "my-time/hooks";
import { OcPageNameTitle, OcPageTransition } from "oc/components";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";

export const MyTimeShowRequestPage = () => {
  const isMobile = useOcIsMobile();
  const { t } = useTranslation();

  const { id, employee } = useParams<{ id: string; employee?: string }>();
  const { data, loading, error } = useMyTimeRequest({ _id: id });

  const {
    data: messagesData,
    loading: messagesLoading,
    error: messagesError,
  } = useMyTimeMessagesList({ request: id });

  return (
    <OcPageTransition>
      <OcPageNameTitle title={t("OC_REQUESTS_DETAILS")} goBack={true} />
      <Box
        padding={isMobile ? "0px 0px 16px 0px" : "0px 16px 16px 16px"}
        display="flex"
        flexDirection="column"
        justifyContent="flex-start"
        alignItems="center"
      >
        <MyTimeShowRequestCard
          data={data}
          messages={messagesData}
          loading={loading || messagesLoading}
          error={error || messagesError}
          employeeCode={employee ?? ""}
        />
      </Box>
    </OcPageTransition>
  );
};

export default MyTimeShowRequestPage;
